import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
// @ts-ignore
import './CustomRegForm.scss';
import { useNavigate } from 'react-router-dom';
import {Spinner } from '@bphxd/ds-core-react';
import { useUser } from '../../../contexts/userContextApi';
import { vendorDetailsGetByEmail, vendorDetailsUpdateByEmail } from '../../../api/endpoints';
import { useMsal } from '@azure/msal-react';

export interface VendorFormData {
  vendorID?: string;
  vendorEmail?: string;
  firstName: string;
  lastName: string;
  supervisorName: string;
  organizationName: string;
  bpApproverTag: string;
  privacyAccepted?: boolean;
  formComplete?: boolean;
  countryName: string;
  region: string;
  supervisorEmail: string;
};

type VendorFormFlags = {
  [K in keyof VendorFormData]: boolean;
};

const CustomRegForm: React.FC = ({}) => {
  const { instance, accounts } = useMsal();

  const account = accounts[0];

  const email =
    account?.username ||
    account?.idTokenClaims?.preferred_username;

  console.log("User Email:", email);
  //sessionStorage.setItem('vendorUsername', email || '');
  const { isAuthorize} = useUser();
  const hasFetchedRef = useRef(false);
  const [isloading, setIsloading] = useState(true);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [formData, setFormData] = useState<VendorFormData>({
    vendorID: '',
    vendorEmail: '',
    firstName: '',
    lastName: '',
    supervisorName: '',
    organizationName: '',
    bpApproverTag: '',
    privacyAccepted: false,
    formComplete: false,
    countryName: '',
    region: '',
    supervisorEmail: '',
  });
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState({
    firstName: false,
    lastName: false,
    supervisorName: false,
    organizationName: false,
    bpApproverTag: false,
    countryName: false,
    region: false,
    supervisorEmail: false,
    privacyAccepted: false,
  });

  const token = sessionStorage.getItem('jwt')
  const [fieldState, setFieldState] = useState<VendorFormFlags>({
    firstName: false,
    lastName: false,
    supervisorName: false,
    organizationName: false,
    bpApproverTag: false,
    countryName: false,
    region: false,
    supervisorEmail: false,
  });
  useEffect(() => {
    const fetchData = async () => {
      try {
        if(!isAuthorize){
          navigate('/')
          return
        }

        const encodedEmail = encodeURIComponent(email as string);
        const response = await axios.get(`${vendorDetailsGetByEmail}?vendor_email=${encodedEmail}`,{
          method: 'get',
          headers: {
            'x-api-key':"gmedocumenthubtest.castrol.com",
            'Content-Type': 'application/json',
            Authorizationtoken: `Bearer ${token}`
          }
        });
        const data:any = response.data.body
        if(!data.vendor_id || !data.vendor_email){
          throw 'Vendor email id is not present.';
        }
        setFormData({
          vendorID: data.vendor_id,
          vendorEmail: data.vendor_email,
          firstName: data.first_name || '',
          lastName: data.last_name || '',
          supervisorName: data.supervisor_name || '',
          countryName: data.country_name || '',
          organizationName: data.vendor_organization_name || '',
          bpApproverTag: data.bp_approver_tag || '',
          privacyAccepted: false,
          formComplete: data.is_form_completed,
          region: data.region || '',
          supervisorEmail: data.supervisor_email || '',
        });
        setFieldState({
          firstName: data.first_name ? true : false,
          lastName: data.last_name ? true : false,
          supervisorName: data.supervisor_name ? true : false,
          organizationName: data.vendor_organization_name ? true : false,
          bpApproverTag: data.bp_approver_tag ? true : false,
          countryName: data.country_name ? true : false,
          region: data.region ? true : false,
          supervisorEmail: data.supervisor_email ? true : false,
        });
        setIsloading(false);
        if (data.is_form_completed) {
          navigate('/drn')
        }
      } catch (error) {
        console.error('Error fetching data', error);
        setIsloading(false);
      }
    };

    if (!sessionStorage.getItem('dataFetched') && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      fetchData();
    } else if (sessionStorage.getItem('dataFetched')) {
      navigate('/drn');
    }
  }, [isAuthorize, navigate, token]);
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         if(!isAuthorize){
//           navigate('/')
//           return
//         }
//         // setIsAuthorize(true);
//         const vendor_email = sessionStorage.getItem('vendorUsername') || '';
//         const encodedEmail = encodeURIComponent(vendor_email)
//         const response = await axios.get(`${vendorDetailsGetByEmail}?vendor_email=${encodedEmail}`,{
//           method: 'get',
//           headers: {
//             'x-api-key':"gmedocumenthubtest.castrol.com",
//             'Content-Type': 'application/json',
//             Authorizationtoken: `Bearer ${token}`
//           }
//         }
//           );
//         const data:any = response.data.body
// //         data = {
// //   "vendor_id": "cbb07f27-2f85-4b57-934c-6904cd1bbbb4",
// //   "vendor_email": "sudipnayek20100@gmail.com",
// //   "first_name": null,
// //   "last_name": null,
// //   "vendor_organization_name": null,
// //   "supervisor_name": null,
// //   "is_form_completed": false,
// //   "privacy_accepted": false,
// //   "bp_approver_tag": null,
// //   "external_id": "3466171e-b2d3-445f-917e-78ef3ad6516b",
// //   "country_name": null,
// //   "region": null,
// //   "supervisor_email": null,
// //   "created_date": "2024-12-09 13:07:29.793788",
// //   "updated_date": "2024-12-09 13:07:29.793788"
// // }
//         if(!data.vendor_id || !data.vendor_email){
//           throw 'Vendor email id is not present.';
//         }
//         setFormData({
//           vendorID: data.vendor_id,
//           vendorEmail: data.vendor_email,
//           firstName: data.first_name || '',
//           lastName: data.last_name || '',
//           supervisorName: data.supervisor_name || '',
//           countryName: data.country_name || '',
//           organizationName: data.vendor_organization_name || '',
//           bpApproverTag: data.bp_approver_tag || '',
//           privacyAccepted: false,
//           formComplete: data.is_form_completed,
//           region: data.region || '',
//           supervisorEmail: data.supervisor_email || '',
//         });
//         setFieldState({
//           firstName: data.first_name ? true : false,
//           lastName: data.last_name ? true : false,
//           supervisorName: data.supervisor_name ? true : false,
//           organizationName: data.vendor_organization_name ? true : false,
//           bpApproverTag: data.bp_approver_tag ? true : false,
//           countryName: data.country_name ? true : false,
//           region: data.region ? true : false,
//           supervisorEmail: data.supervisor_email ? true : false,
//         });
//         setIsloading(false);
//         if (data.is_form_completed) {
//           navigate('/drn')
//         }
//       } catch (error) {
//         console.error('Error fetching data', error);
//         setIsloading(true);
//       }
//     };

//     if (!sessionStorage.getItem('dataFetched')) {
//       fetchData();
//     } else {
//       navigate('/drn');
//     }
//   }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });

    setFormErrors({
      ...formErrors,
      [name]: false,
    });
    // if (name === 'privacyAccepted' && type === 'checkbox' && checked) {
    //   window.alert('I Agree And Accept The Privacy Policy ');
    // }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const errors = {
      firstName: !formData.firstName,
      lastName: !formData.lastName,
      organizationName: !formData.organizationName,
      bpApproverTag: !formData.bpApproverTag,
      countryName: !formData.countryName,
      region: !formData.region,
      supervisorName: !formData.supervisorName,
      privacyAccepted: !formData.privacyAccepted,
      supervisorEmail: !formData.supervisorEmail,
    };

    setFormErrors(errors);

    if (Object.values(errors).some(error => error)) {
      return;
    }

    try {
      const updatedFormData = { ...formData, formComplete: true };
      setIsFormSubmitted(true);
      await axios.post(`${vendorDetailsUpdateByEmail}`,
         updatedFormData, {
        headers: {
          'x-api-key':"gmedocumenthubtest.castrol.com",
          'Content-Type': 'application/json',
          Authorizationtoken: `Bearer ${token}`,
        },
      });
      sessionStorage.setItem('dataFetched', 'true');
      navigate('/information');
      setIsFormSubmitted(false);
    } catch (error) {
      console.error('Error submitting data', error);
      setIsFormSubmitted(false);
    }
  };

  if(!isAuthorize){
    return null
  } else
  return (isFormSubmitted
    ? (<div className="landing-loader">
        <Spinner color="brand" />
      </div>)   
    : isloading
    ? (<div className="landing-loader">
        <Spinner color="brand" />
      </div>)
    : (
      <div className='bg-image'>
      <div className="padding">
        {!isloading && (
          <div className="custom-reg-form-container">
            <h2 className="form-heading">Please provide your details</h2>
            <form className="custom-reg-form" onSubmit={handleSubmit}>


              <div className="form-grid">
                <div className="form-group">
                  <label>Email Id</label>
                  <input type="text" name="vendorEmail" value={formData.vendorEmail} readOnly disabled />
                </div>
              <div className="form-group">
                  <label>Vendor Organization Name<span className="required"> *</span></label>
                  <input type="text" name="organizationName" value={formData.organizationName} readOnly={fieldState.organizationName} disabled={fieldState.organizationName} onChange={handleChange} />
                  {formErrors.organizationName && <span className="error">Organization Name is required</span>}                
                </div>
                <div className="form-group">
                  <label>First name<span className="required"> *</span></label>
                  <input type="text" value={formData.firstName} name="firstName" readOnly={fieldState.firstName} disabled={fieldState.firstName} onChange={handleChange} />
                  {formErrors.firstName && <span className="error">First Name is required</span>}
                </div>
                <div className="form-group">
                  <label>Last name<span className="required"> *</span></label>
                  <input type="text" value={formData.lastName} name="lastName" readOnly={fieldState.lastName} disabled={fieldState.lastName} onChange={handleChange} />
                  {formErrors.lastName && <span className="error">Last Name is required</span>}
                </div>
                <div className="form-group">
                  <label>Country name<span className="required"> *</span></label>
                  <input type="text" value={formData.countryName} name="countryName" readOnly={fieldState.countryName} disabled={fieldState.countryName} onChange={handleChange} />
                  {formErrors.countryName && <span className="error">Country Name is required</span>}
                </div>
                <div className="form-group">
                  <label>Region<span className="required"> *</span></label>
                  <input type="text" value={formData.region } name="region" readOnly={fieldState.region} disabled={fieldState.region} onChange={handleChange} />
                  {formErrors.region && <span className="error">Region is required</span>}
                </div>
                <div className="form-group-inline">
                  <div className="form-group">
                    <label>Supervisor Name<span className="required"> *</span></label>
                    <input type="text" name="supervisorName" value={formData.supervisorName} onChange={handleChange} />
                    {formErrors.supervisorName && <span className="error">Supervisor Name is required</span>}
                  </div>
                  <div className="form-group" style={{marginRight:'20px'}}>
                    <label>Supervisor Email<span className="required"> *</span></label>
                    <input type="email" name="supervisorEmail" value={formData.supervisorEmail} onChange={handleChange} />
                    {formErrors.supervisorEmail && <span className="error">Supervisor Email is required</span>}
                  </div>
                </div>
                <div className="form-group">
                  <label>Bp Approver Tag<span className="required"> *</span></label>
                  <input type="text" name="bpApproverTag" value={formData.bpApproverTag} readOnly={fieldState.bpApproverTag} disabled={fieldState.bpApproverTag} onChange={handleChange} />
                  {formErrors.bpApproverTag && <span className="error">Bp Approver Tag is required</span>}
                </div>
                <div className="form-group">
                  <label >
                    <input type="checkbox" name="privacyAccepted"  checked={formData.privacyAccepted}  onChange={handleChange} />
                    Click Here To Read & Accept The<a href="https://bp365.sharepoint.com/:b:/r/sites/GMEDocHUB/Shared%20Documents/Documents/GME%20Document%20Hub%20Privacy%20statement.pdf?csf=1&web=1&e=ntWmDC" target="_blank"rel="noopener noreferrer"> Privacy Policy</a>
                  </label>
                  {formErrors.privacyAccepted && <span className="error">You must accept the privacy policy</span>}
                </div>
                {/* {<Button level='secondary' rounded='pill'type="submit" disabled={!formData.privacyAccepted || !formData.supervisorName || !formData.bpApproverTag}>Submit</Button>} */}
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>)
    )
};

export default CustomRegForm;